import ArrowRight16 from '@carbon/icons-react/es/arrow--right/16';
import { Result } from 'antd';
import React, { FC } from 'react';
import { Button } from 'components/atoms/button';
import { PageLoading } from 'components/atoms/loading';
import { MagicLinkGeneratePage } from 'components/molecules/session-setup';
import { RoutePaths } from 'constant';
import { useLoginWithToken } from 'hooks/use-login-with-token';
import { useQueryParams } from 'hooks/use-query-params';
import { useTranslation } from 'hooks/use-translation';
import { TokenType } from 'services';

export const SessionError = () => {
  return (
    <Result
      status="error"
      title={useTranslation('session.error.title')}
      subTitle={useTranslation('session.error.message')}
      extra={[
        <Button
          type="primary"
          key="new-magic-link"
          href={RoutePaths.newMagicLink}
          icon={<ArrowRight16 />}
          iconPlacement="right"
        >
          {useTranslation('magic_link.new')}
        </Button>,
      ]}
    />
  );
};

export const MagicLinkPage: FC = () => {
  const params = useQueryParams();
  const token = params.get('token') ?? '';
  // In some cases customer will generate the token and pass it via url
  const extToken = params.get('rl-token') ?? '';
  const tokenType = extToken ? TokenType.External : TokenType.Rocketlane;
  const [isLoading, isError] = useLoginWithToken(
    token || extToken || '',
    tokenType,
  );

  if (isLoading) {
    return <PageLoading />;
  }

  return isError ? <MagicLinkGeneratePage /> : null;
};
